var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 9L1 5L5 1","stroke":"#121212","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }